export const DEFAULT_PROFILE_TAB = "profile";

export const PROFILE_TAB_IDS = [
  "profile",
  "password",
  "security",
  "notifications",
  "privacy",
  "account",
];

/** Legacy ?tab= query values → slug */
const LEGACY_QUERY_MAP = {
  notifications: "notifications",
  profile: "profile",
  password: "password",
  security: "security",
  privacy: "privacy",
  account: "account",
};

export function isValidProfileTab(tab) {
  if (!tab) return false;
  return PROFILE_TAB_IDS.includes(tab);
}

export function profilePath(tab = DEFAULT_PROFILE_TAB) {
  const safeTab = isValidProfileTab(tab) ? tab : DEFAULT_PROFILE_TAB;
  return `/profile/${safeTab}`;
}

/** Parse pathname (+ legacy ?tab= search) into profile tab slug. */
export function parseProfileLocation({ pathname, search }) {
  const parts = pathname.split("/").filter(Boolean);

  if (parts[0] === "profile" && parts[1]) {
    const tab = parts[1].toLowerCase();
    return { tab: isValidProfileTab(tab) ? tab : DEFAULT_PROFILE_TAB };
  }

  if (parts[0] === "profile" && !parts[1]) {
    const params = new URLSearchParams(search || "");
    const legacy = params.get("tab");
    if (legacy && LEGACY_QUERY_MAP[legacy]) {
      return { tab: LEGACY_QUERY_MAP[legacy] };
    }
    return { tab: DEFAULT_PROFILE_TAB };
  }

  return { tab: DEFAULT_PROFILE_TAB };
}

/** Map URL slug to Profile.js panel key (PascalCase). */
export function profileTabToPanelKey(slug) {
  const map = {
    profile: "Profile",
    password: "Password",
    security: "Security",
    notifications: "Notifications",
    privacy: "Privacy",
    account: "Account",
  };
  return map[slug] || "Profile";
}

/** Map panel key to URL slug. */
export function profilePanelKeyToSlug(key) {
  const map = {
    Profile: "profile",
    Password: "password",
    Security: "security",
    Notifications: "notifications",
    Privacy: "privacy",
    Account: "account",
  };
  return map[key] || DEFAULT_PROFILE_TAB;
}
